import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from "react-router-dom";
import { inject, observer } from 'mobx-react';

import { myConst, myMap } from "@config/";
import { browserInfo } from "@utils/browerHandle";
import "./index.scoped.css";

import { AppStore, MapStore, DataStore } from "@/store/";

@inject(stores => ({
    appStore: stores.appStore,
    mapStore: stores.mapStore,
    dataStore: stores.dataStore,
}))
@observer
class Drawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
        };
    }

    toggleBikrOrEmpty = (event) => {
        this.props.appStore.toggleUseOrEmpty({ value: event.target.checked });
        _hmt.push(["_trackEvent", "options", "toggle", "UseOrEmpty"]);
    }
    toggleShowAll = () => {
        let _this = this;
        if (this.state.showAll === true) {
            history.go(0);
            return;
        }
        window.mdui.dialog({
            title: "在地图上显示所有图钉",
            content: `打开此选项会在地图上显示全部（${_this.props.dataStore.onMapList.length}）图钉，可能会严重影响性能，确认开启？`,
            history: false,
            modal: true,
            buttons: [
                {
                    text: "取消",
                    onClick: (v) => {
                        _this.setState({
                            showAll: false,
                        });
                    },
                },
                {
                    text: "确认",
                    onClick(inst) {
                        myConst.minPinDis = 0;
                        myConst.maxShowInMap = _this.props.dataStore.onMapList.length;
                        _this.setState({
                            showAll: true,
                        });
                        myMap.map.centerAndZoom(_this.props.mapStore.defaultLoc.bLoc, 13);
                    },
                },
            ],
        });
    }

    render() {
        const { showAll } = this.state;
        const isMobile = browserInfo.versions.mobile;
        const { appStore } = this.props;
        // const activeItem = {'active':this.props.loca}
        return (
            <div className="mdui-drawer mdui-shadow-12" id="drawer">
                <div className="userView">
                    <img src={require('../../assets/img/logo.png')} alt="logo" className="logo" />
                    <img src={require('../../assets/img/logoBg.png')} alt="background img" className="logoBg" />
                    <div className="bottom">
                        <div className="info">
                            <div className="author mdui-text-color-white-text">建宁驿站查询</div>
                            <div className="slogan mdui-text-color-white-secondary">我是没有简介的简介</div>
                        </div>
                        <div className="flex-spacer"></div>
                        <div className="button">
                            <button className="mdui-btn mdui-ripple mdui-text-color-white-icon" id="drawer-button">
                                <i className="mdui-icon material-icons"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex-spacer"></div>
                <div className="content">
                    <div className="main">
                        <ul className="mdui-list mdui-collapse mdui-list-dense" mdui-collapse="true">
                            <li className="mdui-subheader-inset optionTitle">Options</li>
                            {/* <li className="mdui-list-item mdui-ripple options" mdui-tooltip="{content: '图钉上的数字显示单车数或空位数', position: 'top'}">
                                <i className="mdui-list-item-icon mdui-icon material-icons">edit_location</i>
                                <div className="mdui-list-item-content">图钉显示剩余空位</div>
                                <label className="mdui-switch">
                                    <input type="checkbox" checked={appStore.appState.UseOrEmpty}
                                        onChange={this.toggleBikrOrEmpty} />
                                    <i className="mdui-switch-icon"></i>
                                </label>
                            </li> */}
                            <li className="mdui-list-item mdui-ripple options" mdui-tooltip="{content: '默认只显示附近的图钉', position: 'top'}">
                                <i className="mdui-list-item-icon mdui-icon material-icons">apps</i>
                                <div className="mdui-list-item-content">显示所有图钉</div>
                                <label className="mdui-switch">
                                    <input type="checkbox" checked={showAll} onChange={this.toggleShowAll} />
                                    <i className="mdui-switch-icon"></i>
                                </label>
                            </li>
                            <li className="mdui-subheader-inset"></li>

                            <NavLink to="/map" mdui-drawer-close={isMobile ? "true" : undefined} activeClassName="active">
                                <li className="mdui-list-item mdui-ripple">
                                    <i className="mdui-list-item-icon mdui-icon material-icons">map</i>
                                    <div className="mdui-list-item-content">地图</div>
                                </li>
                            </NavLink>
                            {/* <NavLink to="/record" mdui-drawer-close={isMobile ? "true" : undefined} activeClassName="active">
                                <li className="mdui-list-item mdui-ripple" style={{ 'opacity': 0.3 }}>
                                    <i className="mdui-list-item-icon mdui-icon material-icons">timeline</i>
                                    <div className="mdui-list-item-content">停车记录</div>
                                </li>
                            </NavLink>
                            <li className="mdui-list-item mdui-ripple" style={{ 'opacity': 0.3 }}>
                                <i className="mdui-list-item-icon mdui-icon material-icons">timeline</i>
                                <div className="mdui-list-item-content">欠费查询</div>
                            </li> */}
                            {/* <li className="mdui-list-item mdui-ripple" style={{ 'opacity': 0.3 }} disable="true">
                                <i className="mdui-list-item-icon mdui-icon material-icons">timeline</i>
                                <div className="mdui-list-item-content">停车记录</div>
                            </li> */}
                            <NavLink to="/faq" mdui-drawer-close={isMobile ? "true" : undefined} activeClassName="active">
                                <li className="mdui-list-item mdui-ripple">
                                    <i className="mdui-list-item-icon mdui-icon material-icons">question_answer</i>
                                    <div className="mdui-list-item-content">帮助反馈</div>
                                </li>
                            </NavLink>
                            <NavLink to="/donate" mdui-drawer-close={isMobile ? "true" : undefined} activeClassName="active">
                                <li className="mdui-list-item mdui-ripple">
                                    <i className="mdui-list-item-icon mdui-icon material-icons">local_atm</i>
                                    <div className="mdui-list-item-content">捐赠</div>
                                </li>
                            </NavLink>
                            <NavLink to="/about" mdui-drawer-close={isMobile ? "true" : undefined} activeClassName="active">
                                <li className="mdui-list-item mdui-ripple">
                                    <i className="mdui-list-item-icon mdui-icon material-icons">info</i>
                                    <div className="mdui-list-item-content">关于</div>
                                </li>
                            </NavLink>
                            {
                                appStore.appState.devMode ?
                                    <NavLink to="/dev" mdui-drawer-close={isMobile ? "true" : undefined} activeClassName="active">
                                        <li className="mdui-list-item mdui-ripple">
                                            <i className="mdui-list-item-icon mdui-icon material-icons">bug_report</i>
                                            <div className="mdui-list-item-content">开发</div>
                                        </li>
                                    </NavLink> : null
                            }
                            <li className="mdui-subheader-inset"></li>
                            <a href="https://zhuzhou.city">
                                <li className="mdui-list-item mdui-ripple">
                                    <i className="mdui-list-item-icon mdui-icon material-icons">input</i>
                                    <div className="mdui-list-item-content">株洲城市公共服务</div>
                                </li>
                            </a>
                        </ul >
                    </div >
                    <div className="other"></div>
                </div >
                {/* < button className="mdui-btn" mdui - drawer - close > close</button > */}
            </div >
        );
    }
}

Drawer.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
    mapStore: PropTypes.instanceOf(MapStore).isRequired,
    dataStore: PropTypes.instanceOf(DataStore).isRequired,
};

export default withRouter(Drawer);